import {AfterContentInit, Component, Inject} from '@angular/core';
import {CommonModule} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
  selector: 'details-abilita-conoscenze-dialog',
  templateUrl: './details-abilita-conoscenze-dialog.component.html',
  styleUrls: ['./details-abilita-conoscenze-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, MatListModule, MatTooltipModule],
})
export class DetailsAbilitaConoscenzeDialog implements AfterContentInit {
  listaCompetenze: any;
  constructor(
    public dialogRef: MatDialogRef<DetailsAbilitaConoscenzeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngAfterContentInit(): void {
    this.listaCompetenze = this.data.competenza
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
